export default "__VITE_ASSET__CKhmEY94__"